(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'Chameleon';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("chameleon", TrackingModel);

        if (!Tracker || !Tracker.Properties.ChameleonCode || !Tracker.Properties.ChameleonId || !Tracker.Properties.ChameleonProjectName)
            return;

        var cookieType = Tracker.CookieGroupCode ? Tracker.CookieGroupCode : '';
        var CanTrack = LhApp.Function.Tracking.canTrack(cookieType);

        var _cartAddResponses = []; // holds a response for every cart add action. 
        var _isUserSelectedProduct;

        Init();

        function Track(type, data) {
            var iid = 'iframeChameleon';
            var i = document.getElementById(iid);
            if (!i) {
                i = document.createElement("iframe");
                i.setAttribute('id', iid);
                i.style.width = "0px";
                i.style.height = "0px";
                i.style.position = 'absolute';
                document.body.appendChild(i);
            }

            var d = [Tracker.Properties.ChameleonProjectName, type, Tracker.Properties.ChameleonId, data, Tracker.Properties.ChameleonCode];

            var FVPMS = FVPMS || function () {
                var a = {};
                return {
                    init: function (b) {
                        a = b;
                        var pid_data = encodeURIComponent(a[3]);
                        if (500 < pid_data.length) {
                            pid_data = pid_data.substring(0, 500);
                            var end_pos = pid_data.lastIndexOf("%2C");
                            end_pos = 400 < end_pos ? end_pos : 500;
                            pid_data = pid_data.substring(0, end_pos);
                        }
                        var extra_param = "undefined" == typeof a[4] ? "" : "&exp=" + encodeURIComponent(a[4]);
                        i.src = 'https://dco.gr/beta/public/pm/pmtrack.php?campaign=' + a[0] + "&" + a[1] + "=" + a[2] + "-" + pid_data + extra_param;
                    }
                }
            }();
            FVPMS.init(d);            

            /*
            var src = idocument.createElement('script');
            src.onload = function () {
                iwindow.FVPMS.init(d); 
            };
            src.async = 1;
            src.src = 'https://fv-pm.s3.amazonaws.com/pmtrack.min.js';
            var head = idocument.getElementsByTagName('head')[0];
            head.parentNode.insertBefore(src, head);
            */
        }

        function Init() {            
            if (!CanTrack) return;
            
            //TRACK product list 
            if (TrackingModel.IsProductListPage && TrackingModel.ProductListsData) {
                var ids = [];
                for (var list in TrackingModel.ProductListsData) {
                    var listItems = TrackingModel.ProductListsData[list];
                    for (var i = 0; i < listItems.length; i++) {
                        var product = listItems[i];
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                        if (ids.indexOf(productId) < 0)
                            ids.push(productId);
                    };
                }
                if (ids.length > 0)
                    Track('sid', '[' + ids.join(',') + ']');
            }
            //TRACK product details
            else if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductData && TrackingModel.ProductData.length > 0) {
                var product = TrackingModel.ProductData[0];
                var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                Track('pid', '[' + productId + ']');
            }
            //TRACK order completion
            else if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                Track('thankyou', '[' + TrackingModel.Order.Id + '^' + TrackingModel.Order.TotalPrice + ']');
            }
            else {
                Track('all', '');
            }
        }

        // IMPORTANT execute this scripts in all other pages except checout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            //On consents update, re-initialize this tracker
            Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, TrackingScriptName, function () {
                CanTrack = LhApp.Function.Tracking.canTrack(cookieType);
                Init();
            });

            //HELPER this script keep track of products added to cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                var res = envelope.message.data;
                _cartAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                    Quantity: parseFloat(res.qty)
                });

            });
            //TRACK add to cart (recorded by the ABOVE script)
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                var cartModel = envelope.message.data.Cart;
                //var _cartAddResponses = _cartAddResponses.slice();

                var pAddResponse = _cartAddResponses.shift();
                (function AddToCartTrack(p) {
                    if (!p)
                        return;

                    var pCartItemModel = cartModel.Items.find(function (i) {
                        return i.ProductId == p.ProductId && i.VariantId == p.SkuId;
                    });

                    if (pCartItemModel) {
                        var product = pCartItemModel;
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                        Track('cartpid', '[' + productId + ']');
                    }

                    AddToCartTrack(_cartAddResponses.shift());

                })(pAddResponse);

            });

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, TrackingScriptName, function (envelope) {
                //determine if this has been auto raised during product details load in order to avoid tracking twice the product view
                _isUserSelectedProduct = envelope.message.data.visitorInitiated;
            });
            //TRACK product view (changed)
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if(!_isUserSelectedProduct)
                return;

                var model = envelope.message.data.model;

                var product = model;
                var productId = LhApp.Function.Tracking.getFeedItemId(product, 'ProductChanged', Tracker);

                Track('pid', '[' + productId + ']');
            });
        }
    });
})();